import {AjaxRequest} from '../../utils/ajax-request.js';

export const SoldDatesCalendar = {
	selectors: {
		calendars: Array.prototype.slice.call(document.querySelectorAll('.js-solddatescalendar'))
	},

	init: function() {
		var self = this;

		this.selectors.calendars.forEach((x) => {self.datepickerRender(x, x.dataset.id, x.dataset.url);})
	},

	datepickerRender: function(_selector, _dealID, _serviceURL) {
		var self = this;

		AjaxRequest.create(`${_serviceURL}?id=${_dealID}`)
			.then(result => self.datepickerPlugin(_selector, result))
			.catch(err => AjaxRequest.handleError(err))
	},

	datepickerPlugin: function(_selector, _response) {
		let maxDate = _response.maxDate;
		let minDate = _response.minDate;
		let defaultDate = _response.defaultDate;
		let available = _response.available;
		let soldDates = _response.soldDates;
		let soldDatesText = _response.fullText;
		let unavailable = _response.unavailable;
		let unavailableText = _response.unavailableText;
		let icons = _response.icons;
		let arrowRightHtml = `<span class="icon-svg icon-svg__icon-arrow-circle-right" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="` + icons + `#icon-arrow-circle-right"></use></svg></span>`;
		let arrowLeftHtml = `<span class="icon-svg icon-svg__icon-arrow-circle-left" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="` + icons + `#icon-arrow-circle-left"></use></svg></span>`;

		window.flatpickr(_selector, {
			'dateFormat': 'Y-m-d',
			'inline': true,
			'static': true,
			'minDate': minDate,
			'maxDate': maxDate,
			'defaultDate': defaultDate,
			'nextArrow': arrowRightHtml,
			'prevArrow': arrowLeftHtml,
            'locale': {
                firstDayOfWeek: 2
            },
			onDayCreate: function(dObj, dStr, fp, dayElem) {
				let date = window.flatpickr.formatDate(dayElem.dateObj, fp.config.dateFormat);

				// console.log(dayElem);

				// dayElem.innerHTML += `<span class="c-datepicker__tooltip">Dostupne</span>`;

				dayElem.classList.add('available');

				unavailable.forEach(function(x, i) {
					if (x === date) {
						let startEndDayObj = detectStartEndDay(x);

						dayElem.classList.add('unavailable');
						dayElem.classList.remove('sold');
						dayElem.classList.remove('available');

						dayElem.innerHTML += `<span class="c-datepicker__tooltip">${unavailableText}<span class="c-datepicker__tooltip-arrow"></span></span>`;

						// IF START DAY
						if (startEndDayObj.startDay !== unavailable[i-1]) {
							// when is after day we dont care about start day style
							if (!dayElem.classList.contains('disabled')) {
								dayElem.classList.add('startDay');
							}
						}

						// IF END DAY
						if (startEndDayObj.endDay !== unavailable[i+1]) {
							dayElem.classList.add('endDay');
						}
					}
				});

				soldDates.forEach(function(x, i) {
					// Do not mark date as sold out, if it's unavailable already
					if (x === date && ! dayElem.classList.contains('unavailable')) {
						let startEndDayObj = detectStartEndDay(x);

						dayElem.classList.add('sold');
						dayElem.classList.remove('available');

						dayElem.innerHTML += `<span class="c-datepicker__tooltip">${soldDatesText}<span class="c-datepicker__tooltip-arrow"></span></span>`;

						// IF START DAY
						if (startEndDayObj.startDay !== soldDates[i-1]) {
							// when is after day we dont care about start day style
							if (!dayElem.classList.contains('disabled')) {
								dayElem.classList.add('startDay');
							}
						}

						// IF END DAY
						if (startEndDayObj.endDay !== soldDates[i+1]) {
							dayElem.classList.add('endDay');
						}
					}
				});

				available.forEach(function(x, i) {
					if (x === date) {
						let startEndDayObj = detectStartEndDay(x);

						// IF START DAY
						if (startEndDayObj.startDay !== available[i-1]) {
							// when is after day we dont care about start day style
							if (!dayElem.classList.contains('disabled')) {
								dayElem.classList.add('startDay');
							}
						}

						// IF END DAY
						if (startEndDayObj.endDay !== available[i+1]) {
							dayElem.classList.add('endDay');
						}
					}
				});

				function detectStartEndDay(day) {
					let d = new Date(day);
					let beforeD = new Date(d - 1000 * 60 * 60 * 24);
					let beforeDayFormated = window.flatpickr.formatDate(beforeD, fp.config.dateFormat);
					let nextD = new Date(d.getTime() + (24 * 60 * 60 * 1000));
					let nextDayFormated = window.flatpickr.formatDate(nextD, fp.config.dateFormat);

					return {'startDay': beforeDayFormated, 'endDay': nextDayFormated}
				}
			},
			onReady: function() {
				// 17.1.2019 - disabled per Stepan request, will be reworked later
				//let html = `<ul class="c-datepicker-legend__list"><li class="c-datepicker-legend__item unavailable">${unavailableText}</li><li class="c-datepicker-legend__item sold">${soldDatesText}</li></ul>`;
				//document.querySelector('.c-datepicker-legend').innerHTML += html;

				this.calendarContainer.offsetParent.classList.add('c-datepicker', 'c-datepicker--inline', 'c-datepicker--no-hover', 'c-datepicker--no-select');
				this.calendarContainer.classList.add('c-datepicker__inner');
			},
			onChange() {
				let doIWantToEmitChangeEvent = false; // no I fuckin don't!
				this.clear(doIWantToEmitChangeEvent);
			}
		});
	}
}

SoldDatesCalendar.init();
